import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";
const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  border: `1px solid ${teal}`,
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};

const GROUP_BY_OPTIONS = [
  "Fund",
  "Scheme",
  "Category",
  "Transaction",
  "Rate",
  "Relationship Manager",
  "Sub Broker",
  "Family Head",
  "Client",
];

export default function IncomeDetail() {
  const [dateFrom, setDateFrom] = useState("01-01-2026");
  const [dateTo, setDateTo] = useState("31-01-2026");
  const [groupBy, setGroupBy] = useState("Fund");
  const [category, setCategory] = useState("");
  const [funds, setFunds] = useState("All");
  const [arn, setArn] = useState("All");
  const [selectUser, setSelectUser] = useState("");
  const [location, setLocation] = useState("All");
  const [brokerageType, setBrokerageType] = useState("All");
  const [minAmount, setMinAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState("");
  const [transactionDateAfter, setTransactionDateAfter] = useState("");
  const [clawBackOnly, setClawBackOnly] = useState(false);
  const [includePayoutColumns, setIncludePayoutColumns] = useState(false);
  const [viewType, setViewType] = useState("onScreen");

  const handleGo = (e) => {
    e.preventDefault();
    console.log("Report Configuration", { dateFrom, dateTo });
  };

  const handleApply = (e) => {
    e.preventDefault();
    console.log({
      dateFrom,
      dateTo,
      groupBy,
      category,
      funds,
      arn,
      selectUser,
      location,
      brokerageType,
      minAmount,
      maxAmount,
      transactionDateAfter,
      clawBackOnly,
      includePayoutColumns,
      viewType,
    });
  };

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Income Detail</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/brokerage/income-detail">Brokerage</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Income Detail
                </li>
              </ol>
            </nav>
          </div>

          {/* Report Configuration bar */}
          <div style={cardStyle}>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <div className="d-flex align-items-center gap-2">
                <span
                  style={{
                    width: 28,
                    height: 28,
                    borderRadius: "50%",
                    background: "#e2e8f0",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#64748b",
                    fontSize: "14px",
                  }}
                  aria-hidden
                >
                  −
                </span>
                <span className="fw-semibold text-secondary">Report Configuration</span>
              </div>
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <span className="position-relative d-inline-block">
                  <input
                    type="text"
                    placeholder="DD-MM-YYYY"
                    value={dateFrom}
                    onChange={(e) => setDateFrom(e.target.value)}
                    style={{ ...inputStyle, paddingLeft: 36, width: 130 }}
                    maxLength={10}
                  />
                  <span
                    className="position-absolute"
                    style={{ left: 10, top: "50%", transform: "translateY(-50%)", color: "#64748b", pointerEvents: "none", fontSize: "14px" }}
                    aria-hidden
                  >
                    📅
                  </span>
                </span>
                <span style={{ color: "#64748b" }}>-</span>
                <span className="position-relative d-inline-block">
                  <input
                    type="text"
                    placeholder="DD-MM-YYYY"
                    value={dateTo}
                    onChange={(e) => setDateTo(e.target.value)}
                    style={{ ...inputStyle, paddingLeft: 36, width: 130 }}
                    maxLength={10}
                  />
                  <span
                    className="position-absolute"
                    style={{ left: 10, top: "50%", transform: "translateY(-50%)", color: "#64748b", pointerEvents: "none", fontSize: "14px" }}
                    aria-hidden
                  >
                    📅
                  </span>
                </span>
                <button
                  type="button"
                  onClick={handleGo}
                  style={{
                    background: teal,
                    color: "#fff",
                    border: "none",
                    padding: "8px 20px",
                    borderRadius: "6px",
                    fontWeight: 600,
                    fontSize: "14px",
                    cursor: "pointer",
                  }}
                >
                  Go
                </button>
              </div>
            </div>
          </div>

          {/* Main form card */}
          <div style={cardStyle}>
            <form onSubmit={handleApply}>
              {/* Group By */}
              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-2 d-block">Group By :</label>
                <div className="d-flex flex-wrap gap-3">
                  {GROUP_BY_OPTIONS.map((opt) => (
                    <label key={opt} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                      <input
                        type="radio"
                        name="groupBy"
                        checked={groupBy === opt}
                        onChange={() => setGroupBy(opt)}
                        style={{ accentColor: teal }}
                      />
                      {opt}
                    </label>
                  ))}
                </div>
              </div>

              {/* Filter */}
              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-2 d-block">Filter:</label>
                <div className="row g-3">
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">Category</label>
                    <select value={category} onChange={(e) => setCategory(e.target.value)} style={inputStyle}>
                      <option value="">Select</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">Funds</label>
                    <select value={funds} onChange={(e) => setFunds(e.target.value)} style={inputStyle}>
                      <option value="All">All</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">ARN</label>
                    <select value={arn} onChange={(e) => setArn(e.target.value)} style={inputStyle}>
                      <option value="All">All</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">Select User</label>
                    <span className="position-relative d-inline-block w-100">
                      <select
                        value={selectUser}
                        onChange={(e) => setSelectUser(e.target.value)}
                        style={{
                          ...inputStyle,
                          background: teal,
                          color: "#fff",
                          borderColor: teal,
                          paddingLeft: 36,
                        }}
                      >
                        <option value="">Select User</option>
                      </select>
                      <span
                        className="position-absolute"
                        style={{ left: 10, top: "50%", transform: "translateY(-50%)", color: "rgba(255,255,255,0.9)", pointerEvents: "none" }}
                        aria-hidden
                      >
                        <i className="fa-solid fa-user" style={{ fontSize: "14px" }} />
                      </span>
                    </span>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">Location</label>
                    <select value={location} onChange={(e) => setLocation(e.target.value)} style={inputStyle}>
                      <option value="All">All</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">Brokerage Type</label>
                    <select value={brokerageType} onChange={(e) => setBrokerageType(e.target.value)} style={inputStyle}>
                      <option value="All">All</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">Amount</label>
                    <div className="d-flex gap-2">
                      <input
                        type="text"
                        placeholder="Minimum Amount"
                        value={minAmount}
                        onChange={(e) => setMinAmount(e.target.value)}
                        style={inputStyle}
                      />
                      <input
                        type="text"
                        placeholder="Maximum Amount"
                        value={maxAmount}
                        onChange={(e) => setMaxAmount(e.target.value)}
                        style={inputStyle}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">Transaction Date (&gt;)</label>
                    <input
                      type="text"
                      placeholder="DD-MM-YYYY"
                      value={transactionDateAfter}
                      onChange={(e) => setTransactionDateAfter(e.target.value)}
                      style={inputStyle}
                      maxLength={10}
                    />
                  </div>
                </div>
              </div>

              {/* Checkboxes */}
              <div className="mb-4">
                <label className="d-flex align-items-center gap-2 mb-2" style={{ cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={clawBackOnly}
                    onChange={(e) => setClawBackOnly(e.target.checked)}
                    style={{ accentColor: teal }}
                  />
                  <span className="small fw-semibold text-secondary">Claw back Only</span>
                </label>
                <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={includePayoutColumns}
                    onChange={(e) => setIncludePayoutColumns(e.target.checked)}
                    style={{ accentColor: teal }}
                  />
                  <span className="small fw-semibold text-secondary">Include Payout columns</span>
                </label>
              </div>

              {/* View Type */}
              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-2 d-block">View Type :</label>
                <div className="d-flex gap-4">
                  <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                    <input
                      type="radio"
                      name="viewType"
                      checked={viewType === "onScreen"}
                      onChange={() => setViewType("onScreen")}
                      style={{ accentColor: teal }}
                    />
                    On Screen
                  </label>
                  <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                    <input
                      type="radio"
                      name="viewType"
                      checked={viewType === "xls"}
                      onChange={() => setViewType("xls")}
                      style={{ accentColor: teal }}
                    />
                    XLS
                  </label>
                </div>
              </div>

              <div className="text-center mt-4">
                <button
                  type="submit"
                  style={{
                    background: teal,
                    color: "#fff",
                    border: "none",
                    padding: "10px 28px",
                    borderRadius: "8px",
                    fontWeight: 600,
                    fontSize: "15px",
                    cursor: "pointer",
                  }}
                >
                  Apply
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
